export default {
  path: '/checkout',
  component: () => import('@/feature/checkout/views/CheckoutWrapper.vue'),
  children: [{
    path: '',
    component: () => import('@/views/NotFound.vue'),
  }, {
    path: 'continuar-compra',
    name: 'checkout-fallback',
    component: () => import('@/feature/checkoutFallback/views/CheckoutFallback.vue'),
  }, {
    path: 'continuar-compra/v2',
    name: 'checkout-redirect',
    component: () => import('@/feature/checkoutRedirect/views/CheckoutRedirect.vue'),
  }, {
    path: ':context/pedido-realizado',
    name: 'checkout-vtex-confirmation',
    component: () => import('@/feature/checkout/views/CheckoutVtexConfirmation.vue'),
  }, {
    path: ':context/sumario',
    name: 'checkout-summary',
    component: () => import('@/feature/checkout/views/CheckoutSummary.vue'),
  }, {
    path: ':context/error',
    name: 'checkout-error',
    component: () => import('@/views/Error.vue'),
  }, {
    path: ':context',
    component: () => import('@/feature/checkout/views/CheckoutTemplate.vue'),
    children: [{
      name: 'checkout-init',
      path: '',
      component: () => import('@/feature/checkout/views/CheckoutInit.vue'),
    }, {
      name: 'checkout-info',
      path: 'info',
      component: () => import('@/feature/checkout/views/CheckoutInfo.vue'),
    }, {
      name: 'checkout-feedback-approved',
      path: 'feedback-aprovado',
      component: () => import('@/feature/checkout/views/CheckoutApprovedFeedback.vue'),
    }, {
      name: 'checkout-approved',
      path: 'aprovado',
      component: () => import('@/feature/checkout/views/CheckoutApproved.vue'),
    }, {
      name: 'checkout-approved-grace',
      path: 'aprovado',
      component: () => import('@/feature/checkout/views/CheckoutApprovedGrace.vue'),
    }, {
      name: 'checkout-denied',
      path: 'negado',
      component: () => import('@/feature/checkout/views/CheckoutDenied.vue'),
    },
    {
      path: '*',
      component: () => import('@/views/NotFound.vue'),
    }],
  }],
};
